import React from 'react';
import DashboardLayout from '../components/layouts/DashboardLayout';
import PersonalizedTestHeader from '../components/personalized_tests/PersonalizedTestHeader';
import PersonalizedTestList from '../components/personalized_tests/PersonalizedTestList';
import StatusLegend from '../components/personalized_tests/StatusLegend';

const PersonalizedTests = () => {
  return (
    <DashboardLayout>
      <div className="flex-1 overflow-y-auto p-4 md:p-8 lg:px-12 lg:py-10">
        <div className="max-w-5xl mx-auto flex flex-col gap-6">
          <PersonalizedTestHeader />
          <StatusLegend />
          <PersonalizedTestList />
        </div>
      </div>
    </DashboardLayout>
  );
};

export default PersonalizedTests;